interface StartPayload {
  esiaCode?: string;
  error?: string;
  errorDescription?: string;
}

/**
 * ESIA-код авторизации: в MAX приходит в start_param как base64 JSON,
 * в PWA — в query как ?code=...
 */
export function extractEsiaCode(startParam?: string): string | null {
  if (startParam) {
    try {
      const decoded = JSON.parse(atob(startParam)) as StartPayload;
      if (decoded.esiaCode) return decoded.esiaCode;
    } catch {
      // start_param не в формате base64(JSON) — игнорируем, пробуем query
    }
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('code');
}

/**
 * Достаёт ошибку ESIA-авторизации из start_param (MAX-режим).
 * EsiaCallbackPage кодирует её в payload при неудачном редиректе с ESIA.
 */
export function extractEsiaError(startParam?: string): string | null {
  if (!startParam) return null;

  try {
    const decoded = JSON.parse(atob(startParam)) as StartPayload;
    return decoded.error ?? null;
  } catch {
    return null;
  }
}
